<section class="group-table-wrapper">
    <div class="top-panel titles">{{formItems.tableTitle | translate}} <span
            *ngIf="hiddenCount>0 && formItems.showHiddenMessageWithCurrent"> ({{formItems.showCount}}/{{totalItems}}
        )</span></div>
    <div class="comorbidity-group-table-title">{{formItems.comorbidityTableTitle | translate}} <span
        *ngIf="hiddenCount>0 && formItems.showHiddenMessageWithCurrent"> ({{formItems.showCount}}/{{totalItems}}
        )</span></div>
    <ng-container *ngIf="!formItems?.groupMaxCount; else otherOptions">
        <div class="hidden-content-notification"
         *ngIf="hiddenCount>0 && formItems.showHiddenMessage && !formItems.showHiddenMessageWithCurrent"> {{hiddenCount}}
        hidden Items
        </div>
    </ng-container>
    <ng-template #otherOptions>
        <div class="hidden-content-notification" *ngIf="hiddenCount_item>0"> {{hiddenCount_item}} hidden Item
        </div>
    </ng-template>

    <gen-dynamic-form-table
            *ngIf="!showGroupWithTitle"
            class="group-table"
                        [data]="tableData"
                        [formId]="formItems.formId"
                        [formVertical]="formItems.formVertical"
                        [tableVertical]="formItems.tableVertical"
                        [editMode]="false"
                        [viewAsTable]="formItems.viewAsTable"
                        [disabled] = "formItems.disabled"
                        [titleClass]="formItems?.tableTitleCssClass"
                        [showAddButton]="false"
                        [showDeleteButton]="false"
                        [emptyMessageDisplay]="formItems.emptyMessageDisplay"
                        [customizeRowClassConfig]="formItems.customizeRowClassConfig"
                        [availableCustomClassBasedOn]="formItems.availableCustomClassBasedOn"
                        [hideTitles]="formItems.hideTitles"
></gen-dynamic-form-table>
    <div *ngIf="showGroupWithTitle && groupedTableData">
        <div
             *ngFor="let groupType of groupedTableData | keyvalue">
            <div class="group-title">{{groupType.key}}</div>
            <gen-dynamic-form-table
                    class="group-table"
                    [data]="groupType.value"
                    [formId]="formItems.formId"
                    [formVertical]="formItems.formVertical"
                    [tableVertical]="formItems.tableVertical"
                    [editMode]="false"
                    [disabled] = "formItems.disabled"
                    [showAddButton]="false"
                    [showDeleteButton]="false"
                    [emptyMessageDisplay]="formItems.emptyMessageDisplay"
                    [customizeRowClassConfig]="formItems.customizeRowClassConfig"
                    [availableCustomClassBasedOn]="formItems.availableCustomClassBasedOn"
            ></gen-dynamic-form-table>
        </div>
    </div>
</section>
